<div>
  <app-dialog-title *transloco="let t">
    {{ isCreate ? "Add" : "Update" }} Notice Type
  </app-dialog-title>

  <mat-dialog-content>
    <div class="content">
      @if (!isCreate) {
      <p>Updating {{ noticeType.name }}.</p>
      }
      <form [formGroup]="form" class="ui form">
        <div class="field">
          <label>Notice Name:</label>
          <input formControlName="noticeTypeName" class="form-control" />
        </div>
        <div class="field">
          <label>Display Name:</label>
          <input formControlName="noticeTypeDisplayName" class="form-control" />
        </div>
        <div class="field">
          <label>Notice Type Group:</label>
          <mat-select
            class="selection form-control small"
            formControlName="noticeTypeGroup"
          >
            @for (option of noticeTypeGroupList; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
            }
          </mat-select>
        </div>
        <div class="field">
          <label>Template Type:</label>
          <mat-select
            class="selection form-control small"
            formControlName="templateType"
          >
            @for (option of templateTypeList; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
            }
          </mat-select>
        </div>
      </form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <a class="go-back cancel" (click)="onClose()">Cancel</a>
    <button
      [disabled]="form.invalid"
      (click)="saveNoticeType()"
      class="ui primary button"
    >
      {{ isCreate ? "Add" : "Update" }} Notice Type
    </button>
  </mat-dialog-actions>
</div>
